export class MoleculePanelOverviewHeaderMultiDeleteRedirectionsActionComponent {
    public templateUrl = require('./multi-delete-redirections-action.html?external');
}
